import {
  DialogContent,
  DialogTitle,
  makeStyles,
  Dialog,
  IconButton,
  Checkbox,
} from '@material-ui/core'
import React from 'react'
import CloseIcon from '@material-ui/icons/Close'

const useStyle = makeStyles((theme) => ({
  code: {
    backgroundColor: '#c9c9c9',
    color: '#d20000',
    borderRadius: '4px',
    padding: '2px',
  },
}))

const HelpDialog = (props) => {
  const { open, onClose, hideOnOpen, setHideOnOpen } = props
  const classes = useStyle()
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        <span style={{ fontSize: '25px' }}>Vocabulary Phrases</span>
        <IconButton style={{ float: 'right' }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div>
          <h4>How To Use</h4>
          <div>
            Add a phrase as it should appear in a captions generated from the AI captions. This is
            useful for naming speakers, job titles or truly unique or rare terms that wouldn't
            appear in a dictionary.
            <br/> Examples of good custom vocabulary might be made-up or uniquely spelled words like: <br/>
            <b>sparkletini</b>, <b>Ginnifer</b><br/>
            You should not add terms like <b>e pluribus unum</b> or <b>orthostatic hypotension</b><br/>
            Keep in mind that short phrases do better than long phrases so it's advised to keep
            phrases shorter when possible.
          </div>
        </div>
        <div>
          <h4>General Rules</h4>
          <ul>
            <li>
              Up to 6000 phrases may be submitted per transcription job for English, and up to 1000
              for other languages.
            </li>
            <li>
              Phrases must contain at least one alphabetic character from the respective language.
            </li>
            <li>Phrases cannot be longer than 12 words.</li>
            <li>Individual words cannot be longer than 34 characters.</li>
            <li>
              For English, non-numeric characters in the Basic Latin set are allowed, i.e.
              (U+0000-U+002F and U+003A-U+007F). For other languages, most non-numeric characters in
              the language are allowed.
            </li>
            <li>
              Non-alphabetic characters will be ignored during speech recognition, but will be
              favored in the output. For example, if you submit Yahoo! as a custom vocabulary,
              speech recognition will favor outputting Yahoo! when it recognizes 'yahoo' in the
              audio.
            </li>
          </ul>
        </div>
        <div>
          <h4>Initialisms</h4>
          Initialisms are abbreviations consisting of initial letters pronounced separately, like
          CPU. Submit your initialisms as custom vocabulary to improve their speech recognition.
          <br />
          <ul>
            <li>Initialisms have to contain at least 3 letters</li>
            <li>An initialism will be recognized only when pronounced letter by letter</li>
            <li>{`Ampersands & are supported and will be treated as a letter pronounced like and`}</li>
            <li>Initialisms will be recognized when submitted in the following formats only:</li>
            <ul>
              <li>ABC</li>
              <li>A.B.C.</li>
              <li>a.b.c.</li>
            </ul>
          </ul>
        </div>
        <div>
          <h4>Non-Alphabetic Characters</h4>
          Take note of the following information for some specific characters:
          <ul>
            <li>
              Numbers are not allowed, but note that some common terms like{' '}
              <span className={classes.code}>401k</span> are recognized by default and as such do
              not need to be added as custom vocabulary
            </li>
            <li>
              Standalone ampersands in phrases will be treated like the word{' '}
              <span className={classes.code}>and</span>
            </li>
            <li>
              Dashes in words will be ignored, for example <span>this-and-that</span> will be
              treated as a single word roughly pronounced like <span>this and that</span>
            </li>
          </ul>
        </div>
        <Checkbox
          checked={hideOnOpen === 'true'}
          onChange={(e) => setHideOnOpen(e.target.checked)}
        />{' '}
        <span>Don't show again</span>
      </DialogContent>
    </Dialog>
  )
}

export default HelpDialog
